import React from 'react';

import { ShineMagic } from '@travel/icons/ui';
import { Translate } from '@travel/translation';

import styles from './providerSummary.module.scss';

type Props = {
  AISummary: string;
};

const ProviderSummary = ({ AISummary }: Props) => {
  const termsConditionsTextLabel = <Translate id="Review.AISummary.Notice" />;

  return (
    <div data-testid="ai-summary-container" className={styles.summaryWrapper}>
      <div className={styles.summaryHeading}>
        <ShineMagic size={20} />
        <Translate id="Review.AISummary.Title" className={styles.title} />
      </div>
      <div className={styles.summaryDescriptionContainer}>
        <div className={styles.summaryContent}>{AISummary}</div>
        <div className={styles.termsConditionsContent}>
          <span className={styles.text}>{termsConditionsTextLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default ProviderSummary;
